import { OrderFormat as t } from "@ancon/wildcat-types";
import n from "../time/getTimeSpanParts.mjs";
import { WoltMinimumScheduleDropOffTime as a } from "./constants.mjs";
function l(i, o = "00:00:00", m) {
  const e = n(o), r = e.hours * 60 + e.minutes;
  return (i & t.Delivery) === t.Delivery && m ? Math.max(r, a) : r;
}
export {
  l as default
};
